import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-799ddf60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "woonon-filelist-actions" }

import { withDefaults } from 'vue'
import { DeleteOutlined, FilePdfFilled, FileExcelFilled, FileWordFilled, FileImageFilled } from '@ant-design/icons-vue'

interface Props {
  files: File[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageUploadQueue',
  props: {
    files: { default: () => [] }
  },
  emits: ['deleteFile'],
  setup(__props: any, { emit }) {





function deleteFile (index:number) : void {
  emit('deleteFile', index)
}

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createBlock(_component_a_list, {
    class: "woonon-upload-queue",
    dataSource: __props.files,
    itemLayout: "horizontal"
  }, {
    renderItem: _withCtx(({ item, index }) => [
      _createVNode(_component_a_list_item, null, {
        actions: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_a_popconfirm, {
              title: "Weet je zeker dat je dit bestand wilt verwijderen?",
              placement: "topRight",
              okText: "Ja, verwijderen",
              onConfirm: ($event: any) => (deleteFile(index))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  size: "small",
                  danger: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DeleteOutlined))
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onConfirm"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_list_item_meta, null, {
            avatar: _withCtx(() => [
              (item.type === 'application/pdf')
                ? (_openBlock(), _createBlock(_component_a_avatar, {
                    key: 0,
                    shape: "square",
                    size: 64
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FilePdfFilled), { class: "avatar-icon" })
                    ]),
                    _: 1
                  }))
                : (item.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                  ? (_openBlock(), _createBlock(_component_a_avatar, {
                      key: 1,
                      shape: "square",
                      size: 64
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FileExcelFilled), { class: "avatar-icon" })
                      ]),
                      _: 1
                    }))
                  : (item.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
                    ? (_openBlock(), _createBlock(_component_a_avatar, {
                        key: 2,
                        shape: "square",
                        size: 64
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FileWordFilled), { class: "avatar-icon" })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_avatar, {
                        key: 3,
                        shape: "square",
                        size: 64,
                        src: item.url
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FileImageFilled), { class: "avatar-icon" })
                        ]),
                        _: 2
                      }, 1032, ["src"]))
            ]),
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }, 8, ["dataSource"]))
}
}

})